export var AddressError;
(function (AddressError) {
    AddressError["INVALID"] = "invalid_address";
    AddressError["ENS_NOT_RESOLVED"] = "ens_not_resolved";
})(AddressError || (AddressError = {}));
//# sourceMappingURL=AddressProvider.types.js.map